import { PortalBaseViewController } from '@/views/portal/PortalBaseViewController';
import { TTAPI } from '@/services/TimeTrexClientAPI';
import { TTUUID } from '@/global/TTUUID';

export class JobApplicantSubBaseViewController extends PortalBaseViewController {
	constructor( options = {} ) {
		_.defaults( options, {
			events: {
				'change input[type="text"]': 'onFormItemChange',
				'change input[type="checkbox"]': 'onFormItemChange',
				'change select.form-control': 'onFormItemChange',
				'change textarea.form-control': 'onFormItemChange'
				// 'click .styled-select .glyphicon': 'onSelectClick',
			}
		} );

		super( options );
	}

	preInit( options ) { //Since this is an intermediary class between *SubViewController and PortalBaseViewController, we need to use preInit() so this is called before init() of each child class.
		this.api = TTAPI.APIJobApplicantPortal;
		this.qualification_api = TTAPI.APIQualificationPortal;
		this.company_api = TTAPI.APICompanyPortal;
		this.sub_view_id = options.sub_view_id;
		this.display_columns = options.display_columns;
		this.table_container = options.table_container;
		this.available_fields = options.available_fields;
		this._delegate = options._delegate;
		this.edit_view_error_ui_dic = {};
		this.enable_add_qualification = options.enable_add_qualification || false;

	}

	postInit() {
		if ( !this.model.id ) {
			this.setEditView();
		} else {
			this.render();
		}
	}

	render() {
		var $this = this;
		var list_tpl = Global.loadWidget( 'views/portal/hr/my_profile/MyProfileSubView.html' );
		var unique_id = this.sub_view_id + '-' + this.model.id;
		this.unique_id = unique_id;
		this.sub_view = _.template( list_tpl )( {} );
		if ( this.table_container.find( '.table-container' ).length == 0 ) {
			this.table_container.html( '<div class="table-responsive"><table class="table table-condensed table-bordered table-container"><thead></thead><tbody></tbody></table></div>' );
		}
		if ( this.table_container.find( '#' + unique_id ).length === 0 ) {
			var tbody = $( '<tr>' ).attr( 'id', unique_id );
			$( this.table_container.find( 'tbody' )[0] ).append( tbody );
		} else {
			this.table_container.find( '#' + unique_id ).html( '' );
		}
		var thead = $( '<tr>' );
		for ( var column in this.display_columns ) {
			if ( !this.display_columns.hasOwnProperty( column ) ) {
				continue;
			}
			// comment this, this will cause some default display columns cannot be shown.
			// if ( !this.available_fields.hasOwnProperty( column ) ) {
			// 	continue;
			// }
			var column_val;
			switch ( column ) {
				case 'is_current_employer':
				case 'is_contact_available':
					if ( this.model.get( column ) ) {
						column_val = $.i18n._( 'Yes' );
					} else {
						column_val = $.i18n._( 'No' );
					}
					break;
				default:
					if ( !this.model.get( column ) ) {
						column_val = '';
					} else {
						column_val = this.model.get( column );
					}
					break;
			}
			thead.append( '<th>' + this.display_columns[column] + '</th>' );
			this.table_container.find( '#' + unique_id ).append( '<td>' + column_val + '</td>' );
		}
		thead.append( '<th>' + $.i18n._( 'Action' ) + '</th>' );
		if ( this.table_container.find( 'thead' ).html() === '' ) {
			this.table_container.find( 'thead' ).html( thead );
		}
		this.table_container.find( '#' + unique_id ).append( this.sub_view );
		this.table_container.find( '#' + unique_id ).find( '.edit-icon' ).unbind( 'click' ).bind( 'click', function( e ) {
			$this['get' + $this.sub_view_id]( function() {
				$this.setEditView();
			} );
		} );
		this.table_container.find( '#' + unique_id ).find( '.delete-icon' ).unbind( 'click' ).bind( 'click', function( e ) {
			$this['get' + $this.sub_view_id]( function() {
				$this.onDeleteClick();
			} );
		} );
	}

	initOptions() {
		var $this = this;
		var args = {};
		var filter_data = {};
		filter_data.type_id = [this.qualification_type_id];
		args.filter_data = filter_data;
		args.filter_columns = {
			'id': true,
			'name': true
		};
		this.qualification_api.getQualification( args, true, {
			onResult: function( result ) {
				var res = result.getResult();
				var options = {};
				for ( var i in res ) {
					if ( !res.hasOwnProperty( i ) ) {
						continue;
					}
					var row = res[i];
					options[row.id] = $.i18n._( row.name );
				}
				$this.setSourceData( 'qualification_id', options, true );
			}
		} );
	}

	onSelectClick( e ) {
		var elem = $( e.currentTarget ).parent().find( 'select' );
		if ( document.createEvent ) {
			var e = document.createEvent( 'MouseEvents' );
			e.initMouseEvent( 'mousedown', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null );
			elem[0].dispatchEvent( e );
		} else if ( element.fireEvent ) {
			elem[0].fireEvent( 'onmousedown' );
		}
	}

	setEditView() {
		var tpl = Global.loadWidget( 'views/portal/hr/my_profile/' + this.sub_view_id + 'SubEditView.html' );
		this.setElement( _.template( tpl )( {
			available_fields: this.available_fields,
			enable_add_qualification: this.enable_add_qualification
		} ) );
		this.initOptions();
		this.registerDatePicker();
		this.setCurrentEditRecordData();
		this.openEditView();
	}

	onDeleteClick() {
		var $this = this;
		IndexViewController.instance.router.showConfirmModal( Global.delete_confirm_message, {
			title: '',
			actions: [
				{ label: 'No', isClose: true },
				{
					label: 'Yes', callBack: function( e ) {
						$this.closeConfirmModal();
						ProgressBar.showOverlay();
						$this.api['delete' + $this.sub_view_id]( $this.model.id, {
							onResult: function( result ) {
								ProgressBar.closeOverlay();
								if ( result && result.isValid() ) {
									// $this.remove();
									// $this.table_container.find('#'+$this.unique_id).remove();
									$this._delegate.setSubViews( $this.sub_view_id, $this.display_columns );
								} else {
									$this.showErrorAlert( result );
								}
							}
						} );
					}
				}
			]
		} );
	}

	setSourceData( field, source_data, set_empty ) {
		var $this = this;
		var field_selector = 'select[name="' + field + '"]';
		if ( this.$( field_selector ) && this.$( field_selector )[0] ) {
			this.$( field_selector ).empty();
		} else {
			return;
		}
		if ( !Global.isSet( this.model.get( field ) ) ) {
			this.model.set( field, '' ); // initialize a value;
		}
		if ( _.size( source_data ) == 0 ) {
			set_empty = true;
			this.model.set( field, '' );
		}
		switch ( field ) {
			case 'qualification_id':
				if ( this.enable_add_qualification ) {
					var option_name;
					switch ( this.sub_view_id ) {
						case 'JobApplicantSkill':
							option_name = $.i18n._( 'Add New Skill' );
							break;
						case 'JobApplicantEducation':
							option_name = $.i18n._( 'Add New Course' );
							break;
						case 'JobApplicantLicense':
							option_name = $.i18n._( 'Add New Type' );
							break;
						case 'JobApplicantLanguage':
							option_name = $.i18n._( 'Add New Language' );
							break;
						case 'JobApplicantMembership':
							option_name = $.i18n._( 'Add New Membership' );
							break;
					}
					set_empty = false;
					this.$( field_selector ).append( $( '<option></option>' ).prop( 'value', '' ).text( '-- ' + option_name + ' --' ) );
				}
			//break; -- Do not break here, it should fall through to default.
			default:
				if ( set_empty === true ) {
					this.$( field_selector ).append( $( '<option></option>' ).prop( 'value', '' ).text( '-- ' + $.i18n._( 'None' ) + ' --' ) );
				}
				if ( _.size( source_data ) > 0 ) {
					$.each( source_data, function( value, label ) {
						$this.$( field_selector ).append( $( '<option></option>' ).prop( 'value', value ).text( label ) );
						if ( $this.model.get( field ) == value ) {
							$this.$( field_selector ).val( value );
						}
					} );
				}
				$this.$( field_selector ).selectpicker();
				break;
		}
	}

	registerDatePicker() {
		var time_format = 'h:mm TT';
		var format = 'dd-M-y';
		var focus_out_timer;
		var is_open = false;
		// When portal mode, no user preference.
		// if ( LocalCacheData.getLoginUserPreference() ) {
		// 	format = LocalCacheData.getLoginUserPreference().date_format_1;
		// 	time_format = LocalCacheData.getLoginUserPreference().time_format_1;
		// }
		var day_name_min = [
			$.i18n._( 'Sun' ), $.i18n._( 'Mon' ), $.i18n._( 'Tue' ),
			$.i18n._( 'Wed' ), $.i18n._( 'Thu' ), $.i18n._( 'Fri' ), $.i18n._( 'Sat' )
		];
		var month_name_short = [
			$.i18n._( 'Jan' ), $.i18n._( 'Feb' ),
			$.i18n._( 'Mar' ), $.i18n._( 'Apr' ), $.i18n._( 'May' ),
			$.i18n._( 'Jun' ), $.i18n._( 'Jul' ), $.i18n._( 'Aug' ),
			$.i18n._( 'Sep' ), $.i18n._( 'Oct' ), $.i18n._( 'Nov' ),
			$.i18n._( 'Dec' )
		];
		var current_text = $.i18n._( 'Today' );
		var close_text = $.i18n._( 'Close' );
		var options = {
			showTime: false,
			dateFormat: format,
			showHour: false,
			showMinute: false,
			changeMonth: true,
			changeYear: true,
			showButtonPanel: true,
			duration: '',
			showAnim: '',
			yearRange: '-100:+10',
			showOn: '',
			dayNamesMin: day_name_min,
			currentText: current_text,
			monthNamesShort: month_name_short,
			closeText: close_text,
			beforeShow: function() {
			},
			onSelect: function( dateText ) {
				$( this ).change();
			},
			onClose: function() {
				focus_out_timer = setTimeout( function() {
					is_open = false;
				}, 100 );
			}

		};
		this.$( 'input[type="text"].datepicker' ).datepicker( options );
		this.$( 'input[type="text"].datepicker' ).attr( 'placeholder', 'dd-mmm-yy' );
		this.$( 'input[type="text"].datepicker' ).bind( 'mouseup', function() {
			if ( !is_open ) {
				$( this ).datepicker( 'show' );
				is_open = true;
			} else {
				is_open = false;
				if ( focus_out_timer ) {
					clearTimeout( focus_out_timer );
					focus_out_timer = null;
				}
			}
		} ).next('.glyphicon').bind( 'mouseup', function() { $(this).prev().trigger( 'mouseup' ) } ); // this allows clicking on the calendar icon as well as the input box
	}

	setCurrentEditRecordData() {
		var self = this;
		var unindexed_array = this.$( '.detail-form' ).serializeArray();
		$.map( unindexed_array, function( row, i ) {
			if ( !Global.isSet( self.model.get( row['name'] ) ) ) {
				self.model.set( row['name'], row['value'] );
			}
		} );
		if ( !this.model.has( 'qualification_id' ) ) {
			this.model.set( 'qualification_id', false );
		}
	}

	addQualification() {
		var $this = this;
		var args = {};
		args.type_id = this.qualification_type_id;
		var name = args.name = this.getQualificationWidget().val();
		this.qualification_api.setQualification( args, {
			onResult: function( res ) {
				if ( !res.isValid() ) {
					$this.setErrorTips( res );
				} else {
					$this.$( 'select[name=\'qualification_id\']' ).selectpicker( 'destroy' );
					var new_id = res.getResult();
					$( '<option>' ).attr( {
						selected: 'selected',
						value: new_id
					} ).text( name ).appendTo( $this.$( 'select[name=\'qualification_id\']' ) );
					$this.$( 'select[name=\'qualification_id\']' ).selectpicker();
					$this.$( 'select[name=\'qualification_id\']' ).trigger( 'change' );
				}
			}
		} );
	}

	getAddQualificationContainer() {
		return this.$( '.add-qualification-container' );
	}

	getQualificationWidget() {
		return this.getAddQualificationContainer().find( 'input[name="name"]' );
	}

	showAddQualificationContainer() {
		var $this = this;
		var container = this.getAddQualificationContainer();
		container.css( 'display', 'table' );
		container.find( '.input-group-btn' ).off( 'click' ).on( 'click', function() {
			$this.addQualification();
		} );
		var qualification_widget = this.getQualificationWidget();
		qualification_widget.val( '' );
		qualification_widget.unbind( 'keydown' ).bind( 'keydown', function( e ) {
			if ( e.keyCode === 13 ) {
				$this.addQualification();
			}
		} );
		return container;
	}

	hideAddQualificationContainer() {
		var container = this.getAddQualificationContainer();
		container.css( 'display', 'none' );
		return container;
	}

	// showAddQualificationErrorTip: function () {
	// 	var container = this.getAddQualificationContainer();
	//
	// },

	openEditView() {
		var $this = this;
		IndexViewController.instance.router.showFormModal( this.$el, {
			title: '',
			actions: [
				{
					label: 'Close', isClose: true, callBack: function( e ) {
						//$this.clearErrorTips( true );
					}
				},
				{
					label: 'Save Changes', callBack: function( e ) {
						$this.onSaveClick();
					}
				}
			]
		} );
	}

	closeEditView() {
		IndexViewController.instance.router.hideFormModal();
	}

	closeConfirmModal() {
		IndexViewController.instance.router.hideConfirmModal();
	}

	onFormItemChange( e, doNotValidate ) {
		var key = e.currentTarget.name;
		this.model.set( key, $( e.currentTarget ).val() );
		switch ( key ) {
			case 'qualification_id':
				if ( this.model.get( key ) === '' && this.enable_add_qualification ) {
					this.showAddQualificationContainer();
					doNotValidate = true;
				} else {
					this.hideAddQualificationContainer();
				}
				break;
		}
		if ( !doNotValidate ) {
			this.validate();
		}
	}

	validate() {
		var $this = this;
		// var record = this.current_edit_record;
		// this.api.setJobApplicant
		this.api['validate' + this.sub_view_id]( this.model.toJSON(), {
			onResult: function( result ) {
				$this.validateResult( result );
			}
		} );
	}

	validateResult( result ) {
		// this.clearErrorTips();
		this.setErrorTips( result );
	}

	clearErrorTips( clear_all ) {
		Global.removeErrorTips( Object.values( this.edit_view_error_ui_dic ).map( item => item[0] ), clear_all );
	}

	setErrorTips( result ) {
		this.clearErrorTips( true );
		let error_list = result.getDetails() ? result.getDetails()[0] : {};
		if ( error_list && error_list.hasOwnProperty( 'error' ) ) {
			error_list = error_list.error;
		}
		for ( const key in error_list ) {
			if ( !error_list.hasOwnProperty( key ) ) {
				continue;
			}
			let field_obj;
			if ( this.$( `input[name="${key}"]` )[0] ) {
				field_obj = this.$( `input[name="${key}"]` );
			} else if ( this.$( `select[name="${key}"]` )[0] ) {
				field_obj = this.$( `select[name="${key}"]` ).parents( '.styled-select' );
			} else if ( this.$( `textarea[name="${key}"]` )[0] ) {
				field_obj = this.$( `textarea[name="${key}"]` );
			}
			if ( field_obj ) {
				field_obj.addClass( 'error-tip' );
				let error_string;
				if ( _.isArray( error_list[key] ) ) {
					error_string = error_list[key][0];
				} else {
					error_string = error_list[key];
				}
				const tooltip = new bootstrap.Tooltip( field_obj[0], {
					title: error_string,
					placement: 'right',
					container: 'body',
					trigger: 'hover focus'
				} );

				tooltip.show();
				this.edit_view_error_ui_dic[key] = field_obj;
			}
		}
	}

	showErrorAlert( result ) {
		var details = result.getDetails();

		if ( details.hasOwnProperty( 'error' ) ) {

		}
		if ( !details ) {
			details = result.getDescription(); // If the details is empty, try to get description to show.
		}
		var error_string = '';

		if ( Global.isArray( details ) || typeof details === 'object' ) {

			$.each( details, function( index, val ) {

				if ( val.hasOwnProperty( 'error' ) ) {
					val = val.error;
				}

				for ( var key in val ) {
					error_string = error_string + val[key] + '<br>';
				}
			} );
		} else {

			error_string = details;
		}

		this.showAlert( error_string );
	}

	onSaveClick() {
		var $this = this;
		// if ( _.size(this.edit_view_error_ui_dic) > 0 ) {
		// 	return;
		// }
		this.api['set' + this.sub_view_id]( this.model.toJSON(), {
			onResult: function( result ) {
				if ( result && result.isValid() ) {
					var result_data = result.getResult();
					if ( result_data !== true && TTUUID.isUUID( result_data ) && result_data != TTUUID.zero_id && result_data != TTUUID.not_exist_id ) {
						$this.model.set( 'id', result_data );
					}
					$this.edit_view_error_ui_dic = {};
					$this['get' + $this.sub_view_id]( function() {
						$this.render();
						$this.closeEditView();
					} );
				} else {
					$this.setErrorTips( result );
				}
			}
		} );
	}

	showAlert( content ) {
		IndexViewController.instance.router.showTipModal( content );
	}
}